import daMessages from '@awaze/mfe-common.contexts.intl/localization/translation-files/search-mfe/da.json'
import deMessages from '@awaze/mfe-common.contexts.intl/localization/translation-files/search-mfe/de.json'
import enMessages from '@awaze/mfe-common.contexts.intl/localization/translation-files/search-mfe/en.json'
import esMessages from '@awaze/mfe-common.contexts.intl/localization/translation-files/search-mfe/es.json'
import frMessages from '@awaze/mfe-common.contexts.intl/localization/translation-files/search-mfe/fr.json'
import hrMessages from '@awaze/mfe-common.contexts.intl/localization/translation-files/search-mfe/hr.json'
import itMessages from '@awaze/mfe-common.contexts.intl/localization/translation-files/search-mfe/it.json'
import nbMessages from '@awaze/mfe-common.contexts.intl/localization/translation-files/search-mfe/nb.json'
import nlMessages from '@awaze/mfe-common.contexts.intl/localization/translation-files/search-mfe/nl.json'
import plMessages from '@awaze/mfe-common.contexts.intl/localization/translation-files/search-mfe/pl.json'
import svMessages from '@awaze/mfe-common.contexts.intl/localization/translation-files/search-mfe/sv.json'

export const searchMfeLocaleTranslations = {
  en: enMessages,
  da: daMessages,
  de: deMessages,
  nl: nlMessages,
  nb: nbMessages,
  sv: svMessages,
  es: esMessages,
  fr: frMessages,
  it: itMessages,
  pl: plMessages,
  at: deMessages,
  hr: hrMessages,
}
